import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#002F77"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M90.785 72.843a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-6 4a6 6 0 1 1 12 0 6 6 0 0 1-12 0"
      clipRule="evenodd"
    />
    <path
      fill="#D8FFFF"
      d="M6.566 82.343a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
    />
    <path fill="#00D8D8" d="M8.581 62.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M24.632 88.422a1.5 1.5 0 0 1 0 2.121l-9.993 9.995a1.501 1.501 0 0 1-2.122-2.122l9.993-9.994a1.5 1.5 0 0 1 2.122 0"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M12.518 88.422a1.5 1.5 0 0 1 2.12 0l9.994 9.994a1.5 1.5 0 0 1-2.122 2.122l-9.993-9.995a1.5 1.5 0 0 1 0-2.12M106.566 32.161a1.5 1.5 0 0 1 1.5 1.5v14.134a1.5 1.5 0 0 1-3 0V33.661a1.5 1.5 0 0 1 1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M98 40.728a1.5 1.5 0 0 1 1.5-1.5h14.133a1.5 1.5 0 0 1 0 3H99.5a1.5 1.5 0 0 1-1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#D8FFFF"
      fillRule="evenodd"
      d="M74.29 59.75A2.25 2.25 0 0 1 76.54 62v20.059a2.25 2.25 0 1 1-4.5 0V62a2.25 2.25 0 0 1 2.25-2.25M40.709 66.002a2.25 2.25 0 0 1 2.25 2.25v29.315a2.25 2.25 0 0 1-4.5 0V68.252a2.25 2.25 0 0 1 2.25-2.25"
      clipRule="evenodd"
    />
    <path
      fill="#0597A3"
      d="M58.353 32.66H23.065a4.45 4.45 0 0 0-4.448 4.447v35.288a4.45 4.45 0 0 0 4.448 4.448h35.288a4.45 4.45 0 0 0 4.448-4.448V37.107a4.45 4.45 0 0 0-4.448-4.448"
    />
    <path
      fill="#D8FFFF"
      d="M51 59.592c0-4.47-3.212-7.347-8.182-7.347h-3.636c-2.727 0-2.727-1.2-2.727-1.837s0-1.837 2.727-1.837h7.879c1.503 0 2.727-1.236 2.727-2.755s-1.224-2.755-2.727-2.755h-3.334v-.306C43.727 41.237 42.503 40 41 40s-2.727 1.237-2.727 2.755v.343c-4.449.33-7.273 3.135-7.273 7.31 0 4.47 3.212 7.347 8.182 7.347h3.636c2.727 0 2.727 1.2 2.727 1.837s0 1.837-2.727 1.837H34.94c-1.503 0-2.727 1.236-2.727 2.755s1.224 2.755 2.727 2.755h3.334v.306C38.273 68.763 39.497 70 41 70s2.727-1.237 2.727-2.755v-.343c4.449-.33 7.273-3.135 7.273-7.31"
    />
    <path
      fill="#00D8D8"
      d="M91.934 17.423H56.646a4.45 4.45 0 0 0-4.448 4.448v35.288a4.45 4.45 0 0 0 4.448 4.448h35.288a4.45 4.45 0 0 0 4.448-4.448V21.87a4.45 4.45 0 0 0-4.448-4.448"
    />
    <path
      fill="#D8FFFF"
      d="M84 43.592c0-4.47-3.212-7.347-8.182-7.347h-3.636c-2.728 0-2.728-1.2-2.728-1.837s0-1.837 2.728-1.837h7.879c1.503 0 2.727-1.236 2.727-2.755s-1.224-2.755-2.727-2.755h-3.334v-.306C76.727 25.237 75.503 24 74 24s-2.727 1.237-2.727 2.755v.343c-4.449.33-7.273 3.135-7.273 7.31 0 4.47 3.212 7.347 8.182 7.347h3.636c2.728 0 2.728 1.2 2.728 1.837s0 1.837-2.728 1.837H67.94c-1.503 0-2.727 1.236-2.727 2.755s1.224 2.755 2.727 2.755h3.334v.306C71.273 52.763 72.497 54 74 54s2.727-1.237 2.727-2.755v-.343c4.449-.33 7.273-3.135 7.273-7.31"
    />
  </svg>
);
const SvgEnrichedIconBidsBrand = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconBidsBrand);
export default Memo;
